import React from 'react'
import './WalletContactUs.scss'
import TopNavSubpage from "../../component/TopNav/TopNavSubpage";
import BottomNav from "../../component/BottomNav/BottomNav";
import Loading from "../../component/Loading";
import cogoToast from "cogo-toast";
import * as EmailValidator from 'email-validator';
import ContactUsMutation from "../../mutations/ContactUsMutation";
import {assetUrl} from "../../serviceApi";

const mainImg = assetUrl+'images/contact-us-hero.png'
const subImg = assetUrl+'images/wallet_contactUs_paperRocket.svg'
const email = assetUrl+'images/icon_mail.svg'
const phone = assetUrl+'images/icon_phone.svg'
const arrow = assetUrl+'images/white-arrow-right.png'
const fb = assetUrl+'images/icon_fb.svg'
const insta = assetUrl+'images/icon_insta.svg'
const twitter = assetUrl+'images/icon_twitter.svg'

class WalletContactUs extends React.Component{
    state = {
        email:"",
        name:"",
        message:"",
        loading:false
    }
    handleInputChanges = (e,feild) => {
        this.setState({
            [feild]:e.target.value
        });
    }

    handleSubmit = () => {
        let variable = {
            email:this.state.email,
            name:this.state.name,
            message:this.state.message,
        }
        if(variable.name === ""){
            cogoToast.warn("please fill your name", {position: 'top-center'});
        } else if(EmailValidator.validate(variable.email) === false){
            cogoToast.warn("please fill valid email", {position: 'top-center'});
        } else if(variable.message === ""){
            cogoToast.warn("please fill message", {position: 'top-center'});
        } else {
            this.setState({
                loading: true
            })
            let scope = this;
            ContactUsMutation(variable, function (response) {
                scope.setState({
                    loading: false,
                })
                if (response.contactUs !== null) {
                    cogoToast.success(response.contactUs.message, {position: 'top-center'});
                    setTimeout(
                        function() {
                            scope.resetForm();
                        }
                            .bind(this),
                        1000
                    );


                } else {
                    cogoToast.error(response.contactUs.message, {position: 'top-center'});
                }
            }, function (err) {
                scope.setState({
                    loading: false

                })
                cogoToast.error(err, {position: 'top-center'});
            });
        }
    }
    resetForm = () => {
        this.setState({
            email:"",
            name:"",
            message:"",
        })
    }

    render() {
        const styleContactUs = "wallet-contact-"
        return (
            <Loading loading={this.state.loading}>
                <div className={styleContactUs + "main"}>
                    <TopNavSubpage heading={"Get Help"} notify={false} wallet={false} border={true}/>
                    <div className={styleContactUs + "contentArea container"}
                         // style={window.innerHeight > 700?{height:"85vh"}:{height:"75vh"}}
                    >
                        {/* image */}
                        <div className={"d-flex justify-content-center"}>
                            <div className={styleContactUs + "imageWrapper my-3 text-center"}>
                                <img src={mainImg} alt={'alt'} className={styleContactUs + "main-img"}/>
                                <img src={subImg} alt={'alt'} className={styleContactUs + "sub-img"}/>
                            </div>
                        </div>
                        {/* contacts */}
                        <div className={'d-flex justify-content-between mt-3'}>
                            <div className={"mx-1 text-center"}>
                                <div className={'d-flex justify-content-center'}>
                                    <img src={email} alt={"alt"} className={styleContactUs + "icon mb-1 p-1"}/>
                                </div>
                                <p className={styleContactUs + "contact-value my-2"}>Contact@netapp.com</p>
                            </div>
                            <hr className={styleContactUs+"divider-line"}/>
                            <div className={"mx-1 text-center"}>
                                <div className={'d-flex justify-content-center'}>
                                    <img src={phone} alt={"alt"} className={styleContactUs + "icon mb-1 p-1"}/>

                                </div>
                                <p className={styleContactUs + "contact-value my-2"}>+91 72883 46678</p>
                            </div>
                        </div>
                        {/* input field   */}
                        <div>
                            <input
                                type={"text"}
                                className={styleContactUs + "inputs mt-3 mb-2 p-2"}
                                placeholder={"Name"}
                                value={this.state.name}
                                onChange={(e)=>this.handleInputChanges(e,"name")}
                            />
                            <input
                                type={"email"}
                                className={styleContactUs + "inputs my-2 p-2"}
                                placeholder={"Email Address"}
                                value={this.state.email}
                                onChange={(e)=>this.handleInputChanges(e,"email")}
                            />
                            <textarea
                                className={styleContactUs + "inputs my-2 p-2"}
                                placeholder={"Your Message"}
                                value={this.state.message}
                                onChange={(e)=>this.handleInputChanges(e,"message")}
                            />

                            <button
                                className={styleContactUs + "button py-2 my-2 d-flex justify-content-center align-items-center"}
                                disabled={this.state.loading}
                                onClick={this.handleSubmit}
                            >
                                <p className={"mb-0"}>Send Message</p>
                                <img src={arrow} alt={"alt"} className={' mt-1'} style={{marginLeft:"14px"}}/>
                            </button>


                        </div>
                        {/* socio icons    */}
                        <div className={"text-center  my-4"}>
                            <p className={styleContactUs + "socio-text my-1 "}>Follow us on</p>
                            <div className={'d-flex justify-content-center align-items-center mt-3 mb-5'}>
                                <img src={fb} alt={"alt"} className={styleContactUs + "socio-icon mx-2"}/>
                                <img src={twitter} alt={"alt"} className={styleContactUs + "socio-icon mx-2"}/>
                                <img src={insta} alt={"alt"} className={styleContactUs + "socio-icon mx-2"}/>
                            </div>
                        </div>
                    </div>
                    {/*<div className={styleContactUs + "bottom-nav-wrap"}>*/}
                    {/*    <BottomNav/>*/}
                    {/*</div>*/}

                </div>
            </Loading>
        );
    }
}
export default WalletContactUs
